import { useEffect, useState } from "react";
const popup_delay_s = 5;
const PopupComponent = ({ message, type, closePopup, autoDismiss = true, duration = 2000, countdown }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(true);
    
    if (autoDismiss && type !== "logout") {
      const timer = setTimeout(() => {
        setVisible(false);
        setTimeout(closePopup, popup_delay_s*1000); // Delay removal after fade-out
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [autoDismiss, closePopup, duration, type]);

  const getBackgroundColor = () => {
    switch(type) {
      case "success": return "#10b981"; // green-500
      case "error": return "#ef4444"; // red-500
      case "warning": return "#f59e0b"; // yellow-500
      case "info": return "#3b82f6"; // blue-500
      case "logout": return "rgba(16, 185, 129, 0.5)"; // green-500/50
      default: return "transparent";
    }
  };

  return (
    <div
      className={`fixed top-20 left-1/2 transform -translate-x-1/2 px-6 py-3
        text-lg rounded-lg shadow-lg transition-all duration-500 popup-overlay
        ${visible ? "opacity-100 scale-100 translate-y-0" : "opacity-0 scale-95 translate-y-[-10px]"}`}
      style={{
        backgroundColor: getBackgroundColor(),
        color: 'var(--color-text-white)'
      }}
    >
      {type === "logout" && countdown > 0 ? `⚠️ Logging out in ${countdown} seconds...` : message}
      {(type === "logout" || !autoDismiss) && (
  <button
    onClick={() => {
      if (type === "logout") {
        // For logout popups, call closePopup immediately
        closePopup();
      } else {
        // For other popups, use the fade-out animation
        setVisible(false);
        setTimeout(closePopup, 300);
      }
    }}
    className="ml-4 text-black font-bold text-xl hover:text-gray-200"
  >
    ✖
  </button>
)}
    </div>
  );
};

export default PopupComponent;